/**
 * 전투가 벌어지는 "높이 평면"(px, 발밑 기준. 위쪽이 음수).
 *
 * **왜 이런 게 필요한가**
 * 시뮬레이션은 완전한 2D 평면이다 — 모든 좌표가 바닥에 있고 높이 개념이 없다.
 * 반면 캐릭터는 서 있는 모습으로 그려져서, 무기는 가슴 높이에 달려 있다.
 * 그래서 "월드 좌표 그대로" 그리면 총알만 발밑을 스치듯 날아가 총구와 이어지지 않는다.
 *
 * 이 값만큼 올려 그리는 대상:
 *   - 무기 공전 중심 (weaponFx)
 *   - 투사체 (EntityRenderer)
 *   - 몬스터 몸통 (EntityRenderer)
 *   - 근접 휘두르기 이펙트 (weaponFx)
 *
 * **하나라도 빠지면 어긋난다.** 실제로 총알만 올리고 몬스터는 그대로 두어서
 * 총알이 몬스터 머리 위로 지나가는데 판정은 맞는 상태가 됐던 적이 있다.
 *
 * **조준에도 반영해야 한다.** 마우스 커서는 화면 좌표라 이미 "올려 그려진" 세계를
 * 가리키고 있다. 조준각을 발밑 기준으로 계산하면 총알이 커서보다 이만큼 위로 날아간다.
 * (InputController.updateAim 참고)
 *
 * 판정은 언제나 월드 좌표(발밑)로 이뤄진다 — 이 값은 보이는 위치와 조준 해석에만 쓴다.
 */
export const ACTION_PLANE_Y = -14;
